export function triggerHapticFeedback(style: "light" | "medium" | "heavy" | "success") {
  if (typeof window !== "undefined" && "vibrate" in navigator) {
    switch (style) {
      case "light":
        navigator.vibrate(10)
        break
      case "medium":
        navigator.vibrate(40)
        break
      case "heavy":
        navigator.vibrate([100, 50, 100])
        break
      case "success":
        navigator.vibrate([50, 50, 100])
        break
      default:
        navigator.vibrate(10)
    }
  }
}